import styled from 'styled-components';

export const PassFailBackgroundWrapper = styled('svg')`
  width: 100%;
  height: 100%;
`;
